export default [
  {
    path: "/login",
    name: "login",
    component: () => import("@/pages/login.vue"),
    meta: {
      title: "登录",
      displayable: false, //是否为可显示页面
      isUseCache: false, // 默认不缓存
      hideNav: true,
      keepAlive: true, // 是否使用 keep-alive
    },
  },
  {
    path: "/search",
    name: "search",
    component: () => import("@/pages/search.vue"),
    meta: {
      title: "搜索",
      displayable: false, //是否为可显示页面
      isUseCache: false, // 默认不缓存
      hideNav: true,
      keepAlive: true, // 是否使用 keep-alive
    },
  },
  {
    path: "/view404",
    name: "404",
    component: () => import("@/pages/view404.vue"),
    meta: {
      title: "404",
      displayable: false, //是否为可显示页面
      isUseCache: false, // 默认不缓存
      hideNav: true,
      keepAlive: true, // 是否使用 keep-alive
    },
  },
  {
    path: "/view403",
    name: "403",
    component: () => import("@/pages/view403.vue"),
    meta: {
      title: "403",
      displayable: false, //是否为可显示页面
      isUseCache: false, // 默认不缓存
      hideNav: true,
      keepAlive: true, // 是否使用 keep-alive
    },
  },
  {
    path: "/home",
    name: "home",
    component: () => import("@/pages/home.vue"),
    meta: {
      title: "订单管理",
      displayable: true, //是否为可显示页面
      isUseCache: false, // 默认不缓存
      keepAlive: true, // 是否使用 keep-alive生成记录
    },
  },
  {
    path: "/tixian",
    name: "tixian",
    component: () => import("@/pages/tixian.vue"),
    meta: {
      title: "提现记录",
      displayable: true, //是否为可显示页面
      isUseCache: false, // 默认不缓存
      keepAlive: true, // 是否使用 keep-alive生成记录
    },
  },
  {
    path: "/meet",
    name: "meet",
    component: () => import("@/pages/orderpointgood.vue"),
    meta: {
      title: "产品管理",
      displayable: true, //是否为可显示页面
      isUseCache: false, // 默认不缓存
      keepAlive: true, // 是否使用 keep-alive
    },
  },
  {
    path: "/activity",
    name: "activity",
    component: () => import("@/pages/activity.vue"),
    meta: {
      title: "工人管理",
      displayable: true, //是否为可显示页面
      isUseCache: false, // 默认不缓存
      keepAlive: true, // 是否使用 keep-alive
    },
  },
  {
    path: "/user",
    name: "user",
    component: () => import("@/pages/user.vue"),
    meta: {
      title: "用户管理",
      displayable: true, //是否为可显示页面
      isUseCache: false, // 默认不缓存
      keepAlive: true, // 是否使用 keep-alive
    },
  },
  {
    path: "/wxdd",
    name: "wxdd",
    component: () => import("@/pages/wxdd.vue"),
    meta: {
      title: "维修订单",
      displayable: true, //是否为可显示页面
      isUseCache: false, // 默认不缓存
      keepAlive: true, // 是否使用 keep-alive
    },
  },
  {
    path: "/wtfk",
    name: "wtfk",
    component: () => import("@/pages/wtfk.vue"),
    meta: {
      title: "问题反馈",
      displayable: true, //是否为可显示页面
      isUseCache: false, // 默认不缓存
      keepAlive: true, // 是否使用 keep-alive
    },
  },
  {
    path: "/tzgg",
    name: "tzgg",
    component: () => import("@/pages/tzgg.vue"),
    meta: {
      title: "通知公告",
      displayable: true, //是否为可显示页面
      isUseCache: false, // 默认不缓存
      keepAlive: true, // 是否使用 keep-alive
    },
  },
];
